export { default as ChevronDown } from 'react-feather/dist/icons/chevron-down';

if (typeof ChevronDown !== 'undefined' && ChevronDown && ChevronDown === Object(ChevronDown) && Object.isExtensible(ChevronDown) && !ChevronDown.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ChevronDown, '__filemeta', {
    configurable: true,
    value: {
      name: "ChevronDown",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as ChevronUp } from 'react-feather/dist/icons/chevron-up';

if (typeof ChevronUp !== 'undefined' && ChevronUp && ChevronUp === Object(ChevronUp) && Object.isExtensible(ChevronUp) && !ChevronUp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ChevronUp, '__filemeta', {
    configurable: true,
    value: {
      name: "ChevronUp",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Clipboard } from 'react-feather/dist/icons/clipboard';

if (typeof Clipboard !== 'undefined' && Clipboard && Clipboard === Object(Clipboard) && Object.isExtensible(Clipboard) && !Clipboard.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Clipboard, '__filemeta', {
    configurable: true,
    value: {
      name: "Clipboard",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Code } from 'react-feather/dist/icons/code';

if (typeof Code !== 'undefined' && Code && Code === Object(Code) && Object.isExtensible(Code) && !Code.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Code, '__filemeta', {
    configurable: true,
    value: {
      name: "Code",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Edit } from 'react-feather/dist/icons/edit-2';

if (typeof Edit !== 'undefined' && Edit && Edit === Object(Edit) && Object.isExtensible(Edit) && !Edit.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Edit, '__filemeta', {
    configurable: true,
    value: {
      name: "Edit",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Github } from 'react-feather/dist/icons/github';

if (typeof Github !== 'undefined' && Github && Github === Object(Github) && Object.isExtensible(Github) && !Github.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Github, '__filemeta', {
    configurable: true,
    value: {
      name: "Github",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Menu } from 'react-feather/dist/icons/menu';

if (typeof Menu !== 'undefined' && Menu && Menu === Object(Menu) && Object.isExtensible(Menu) && !Menu.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Menu, '__filemeta', {
    configurable: true,
    value: {
      name: "Menu",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Search } from 'react-feather/dist/icons/search';

if (typeof Search !== 'undefined' && Search && Search === Object(Search) && Object.isExtensible(Search) && !Search.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Search, '__filemeta', {
    configurable: true,
    value: {
      name: "Search",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}

export { default as Sun } from 'react-feather/dist/icons/sun';

if (typeof Sun !== 'undefined' && Sun && Sun === Object(Sun) && Object.isExtensible(Sun) && !Sun.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Sun, '__filemeta', {
    configurable: true,
    value: {
      name: "Sun",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Icons/index.js"
    }
  });
}